module.exports = __webpack_public_path__ + "static/media/logout.7d7c0ba2.svg";